export default "__VITE_ASSET__CcMSt$R6__"